import script from "./HaiqiaoConference.vue?vue&type=script&setup=true&lang=js"
export * from "./HaiqiaoConference.vue?vue&type=script&setup=true&lang=js"

import "./HaiqiaoConference.vue?vue&type=style&index=0&id=a2d3ba86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2d3ba86"]])

export default __exports__